import { render, staticRenderFns } from "./GlobalToastNotification.vue?vue&type=template&id=4b007cfe&scoped=true"
import script from "./GlobalToastNotification.vue?vue&type=script&lang=js"
export * from "./GlobalToastNotification.vue?vue&type=script&lang=js"
import style0 from "./GlobalToastNotification.vue?vue&type=style&index=0&id=4b007cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b007cfe",
  null
  
)

export default component.exports